import Vue from 'vue'
import Router from 'vue-router'
import HomeView from './views/HomeView.vue'

Vue.use(Router)

export default new Router({
	base: '/',
	mode: 'history',
	linkActiveClass : 'routerLink--active',
	linkExactActiveClass : 'routerLink--exactActive',
	routes: [
		/*
		{
			path: '/',
			redirect: '/edit/',
		},
		*/
		{
			path: '/',
			name: 'HomeView',
			pathToRegexpOptions: { strict: true },
			component: HomeView,
		},
		{
			path: '/edit/',
			name: 'EditView',
			pathToRegexpOptions: { strict: true },
			component: () =>
				import ( /* webpackChunkName: "EditView" */ './views/EditView.vue')
		},
		{
			path: '/dev/',
			name: 'DevView',
			pathToRegexpOptions: { strict: true },
			component: () =>
				import ( /* webpackChunkName: "DevView" */ './views/DevView.vue')
		},
		{
			path: "*",
			redirect: '/',
		},
	]
})
